/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import config from "../config/credentialLists.config.json";
import axios from "axios";

import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { GET_CREDENTIAL_LIST } from "../graphql";
import { VApplication } from "../../../application";

import { DEFAULT_APP_CONFIG } from "../../../config/default.config";

import { templateReplacer } from "../../../helpers/template.replace";

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

import { useEmailId } from "../../../pages/IssuedCredentials/provider";

export interface ICredentialListsMethods extends IPluginMethodMap {
  getCredentialIssuedListsProps(args: any): Promise<any>;
}

export interface IGetCredentialIssuedListProps {
  offset?: number;
  size?: number;
  criteria?: any;
}

export class CredentialIssuedListsService implements IAgentPlugin {
  readonly methods: ICredentialListsMethods;

  constructor() {
    this.methods = {
      getCredentialIssuedListsProps: this.getProps.bind(this),
    };
  }

  async getProps(args: IGetCredentialIssuedListProps) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    const { email } = useEmailId();
    let criteria = {};
    if (email) {
      criteria = {
        email: email,
        ...args?.criteria,
      };
    } else {
      criteria = {
        ...args?.criteria,
      };
    }
    try {
      if (client) {
        const res = await client.query({
          query: GET_CREDENTIAL_LIST,
          variables: {
            input: {
              criteria: criteria,
              offset: args?.offset ?? 0,
              size: args?.size ?? 10,
            },
          },
          fetchPolicy: "network-only",
        });
        if (res?.data) {
          console.log(`table data`, res);
          let _rowData = this.formatIssuedCredentialTable(
            res?.data?.getListOfCredential?.data
          );
          return {
            ...(this.getTransformConfig(config) || {}),
            ultUsers: _rowData,
            isEmpty: res?.data?.getListOfCredential?.data?.length <= 0,
            // studentGroup: holderGroups,
            activePage: res?.data?.getListOfCredential?.currentPage,
            pageSize: res?.data?.getListOfCredential?.pageSize,
            totalCount: res?.data?.getListOfCredential?.totalCount,
            totalPages: res?.data?.getListOfCredential?.totalPages,
          };
        }
      }
    } catch (err: any) {
      return {
        isEmpty: true,
      };
    }
  }

  private formatIssuedCredentialTable(tableData: any) {
    let _rowData =
      Array.isArray(tableData) &&
      tableData.map((item: any) => {
        return {
          id: item?.id,
          name: item?.to,
          // image:item?.image,
          credential: item?.name,
          email: item?.email,
          dateCreated: item?.issuanceDate,
          issuer: item?.issuer,
          description: item?.description,
        };
      });
    return _rowData;
  }
  // return { ...(config || {}) };

  private getTransformConfig(data: any) {
    const _transConfig = templateReplacer(JSON.stringify(data), {
      holder_name: DEFAULT_APP_CONFIG?.platformSemantics?.semantics?.holder,
      holders_name: DEFAULT_APP_CONFIG?.platformSemantics?.semantics?.holders,
      holder_group: DEFAULT_APP_CONFIG?.platformSemantics?.HoldersGroups?.title,
      credential: DEFAULT_APP_CONFIG?.platformSemantics?.semantics?.credential,
      credentials:
        DEFAULT_APP_CONFIG?.platformSemantics?.semantics?.credentials,
    });
    return JSON.parse(_transConfig);
  }
}
